import { Controller } from '@hotwired/stimulus'

export default class ExpressionInvestFormController extends Controller {
  static targets = [
    'totalAmount'
  ]

  static values = {
    fees: Number
  }

  formatSmartNumber(value) {
    const newValue = Number.isInteger(value) ? value : Math.round(value * 100) / 100;
    return newValue.toLocaleString("fr-FR");
  }

  updateAmount(e) {
    const amount = e.target.value;
    const percentFees = amount * (this.feesValue / 100);
    const totalAmount = Number(amount) + Number(percentFees);

    this.totalAmountTarget.innerHTML = this.formatSmartNumber(totalAmount);
  }
}
